<div [ngClass]="{'linq-card__header-actions': !removeBottomBorder, 'linq-card__header-actions--no_bottom': removeBottomBorder}">
	<div *ngIf="!hideSearch" class="linq-card__header-group">
		<ng-container *ngIf="{isAccount: isAccountSearch | async} as Obj">
			<mat-form-field floatLabel="always" class="search-input-defaults" [ngClass]="{'account-input': Obj.isAccount}">
				<mat-label>Search</mat-label>
				<input #searchInput matInput placeholder="Search" [ngClass]="{'input-hide': Obj.isAccount}" [disabled]="disableFilters" />
				<input #searchAccountInput matInput placeholder="Search" [ngClass]="{'input-hide': !Obj.isAccount}" [mask]="accountStructure"
					[showMaskTyped]="true" [patterns]="customPatterns" [disabled]="disableFilters" />
				<mat-icon aria-hidden="false" aria-label="Search" matSuffix>search</mat-icon>
			</mat-form-field>
		</ng-container>
	</div>
	<div *ngIf="!searchOnly" class="linq-card__header-group linq-ml-6">
		<button (click)="openFilters($event)" mat-button aria-label="Open filters" [disabled]="disableFilters">
			<span>Filter</span>
			<mat-icon>expand_more</mat-icon>
		</button>
	</div>
	<div *ngIf="!searchOnly" class="linq-card__header-group">
		<mat-chip-set *ngIf="hasFilters()" aria-label="Filter selection">
			<mat-chip *ngFor="let filter of getAppliedFilters(); key: 'key'" (removed)="removeFilter(filter.key)" class="linq-chip">
				{{ showChipKey ? generateChipDisplay(filter) : filter.value }}
				<mat-icon *ngIf="!disableFilters" matChipRemove>close</mat-icon>
			</mat-chip>
			<mat-chip *ngIf="!disableFilters" class="linq-chip" (removed)="clearFilters()" matChipRemove>
				Clear Filters
			</mat-chip>
		</mat-chip-set>
	</div>
	<ng-content></ng-content>
</div>

<ng-template #filtersForm let-filters="filters" let-form="form" let-fields="fields" let-options="options">
	<div class="linq-dialog">
		<div class="linq-dialog__header">
			<h3 class="linq-heading">Filter</h3>
		</div>
		<sl-form class="filter__form" [model]="filters" [fields]="fields" [form]="form" [options]="options" [disableUnsavedChanges]="true"
			(submitted)="onSubmit($event)">
			<div class="linq-dialog__actions">
				<button type="button" (click)="closePopover()" class="linq-button--secondary" mat-stroked-button>
					Cancel
				</button>
				<button [disabled]="form.invalid" class="pull-right linq-button--primary" type="submit" color="primary" mat-flat-button>
					Apply
				</button>
			</div>
		</sl-form>
	</div>
</ng-template>